module.exports = __webpack_public_path__ + "components/roadsurfer/static/roadsurfer-1200-9e71e4b281083901cee63b981bbd343e.jpg";